<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.parkcarout_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/park/car/parkcarout';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        //calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        dialogClickModal: false,
        refreshBtn:false,
        column: [
          {
            label: '',
            prop: 'id',
            rules: [
              {
                required: true,
                message: '请输入',
                trigger: 'change',
              },
            ],
          },
          {
            label: '停车场ID',
            prop: 'parkingLotId',
            rules: [
              {
                required: true,
                message: '请输入停车场ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '区域ID',
            prop: 'regionId',
            rules: [
              {
                required: true,
                message: '请输入区域ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '区域名称',
            prop: 'regionName',
            rules: [
              {
                required: true,
                message: '请输入区域名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '进入通道ID',
            prop: 'outPassageId',
            rules: [
              {
                required: true,
                message: '请输入进入通道ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '通道名称',
            prop: 'outPassageName',
            rules: [
              {
                required: true,
                message: '请输入通道名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车辆识别时间',
            prop: 'outIdentifyTime',
            rules: [
              {
                required: true,
                message: '请输入车辆识别时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车辆识别照片',
            prop: 'outIdentifyImage',
            rules: [
              {
                required: true,
                message: '请输入车辆识别照片',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车牌号码',
            prop: 'plateNumber',
            rules: [
              {
                required: true,
                message: '请输入车牌号码',
                trigger: 'change',
              },
            ],
          },
          {
            label: '套餐编号',
            prop: 'setmealNo',
            rules: [
              {
                required: true,
                message: '请输入套餐编号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '套餐名称',
            prop: 'setmealName',
            rules: [
              {
                required: true,
                message: '请输入套餐名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '是否是月卡车: 1是 0不是',
            prop: 'monthCar',
            rules: [
              {
                required: true,
                message: '请输入是否是月卡车: 1是 0不是',
                trigger: 'change',
              },
            ],
          },
          {
            label: '入场记录id',
            prop: 'inId',
            rules: [
              {
                required: true,
                message: '请输入入场记录id',
                trigger: 'change',
              },
            ],
          },
          {
            label: '入场时间',
            prop: 'inTime',
            rules: [
              {
                required: true,
                message: '请输入入场时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '入场通道ID',
            prop: 'inPassageId',
            rules: [
              {
                required: true,
                message: '请输入入场通道ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '入场通道名称',
            prop: 'inPassageName',
            rules: [
              {
                required: true,
                message: '请输入入场通道名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '出场照片',
            prop: 'outImage',
            rules: [
              {
                required: true,
                message: '请输入出场照片',
                trigger: 'change',
              },
            ],
          },
          {
            label: '出场时间',
            prop: 'outTime',
            rules: [
              {
                required: true,
                message: '请输入出场时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '出入场控制操作员名称',
            prop: 'username',
            rules: [
              {
                required: true,
                message: '请输入出入场控制操作员名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '停车时长 如：1天3小时15分钟',
            prop: 'parkingTime',
            rules: [
              {
                required: true,
                message: '请输入停车时长 如：1天3小时15分钟',
                trigger: 'change',
              },
            ],
          },
          {
            label: '是否付款：0未付款 1已付款 2放弃付款/已重新生成订单/取消',
            prop: 'payStatus',
            rules: [
              {
                required: true,
                message: '请输入是否付款：0未付款 1已付款 2放弃付款/已重新生成订单/取消',
                trigger: 'change',
              },
            ],
          },
          {
            label: '付款时间',
            prop: 'payTime',
            rules: [
              {
                required: true,
                message: '请输入付款时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '支付方式：微信/支付宝/现金',
            prop: 'payType',
            rules: [
              {
                required: true,
                message: '请输入支付方式：微信/支付宝/现金',
                trigger: 'change',
              },
            ],
          },
          {
            label:
              '是否通过平台付款：1是，通过平台支付并回调后自动开闸0否，不通过平台，付款后手动开闸',
            prop: 'payMethod',
            rules: [
              {
                required: true,
                message:
                  '请输入是否通过平台付款：1是，通过平台支付并回调后自动开闸0否，不通过平台，付款后手动开闸',
                trigger: 'change',
              },
            ],
          },
          {
            label: '开闸方式 0 还未开闸 1自动放行 2手动放行',
            prop: 'openType',
            rules: [
              {
                required: true,
                message: '请输入开闸方式 0 还未开闸 1自动放行 2手动放行',
                trigger: 'change',
              },
            ],
          },
          {
            label: '应收金额(单位：元）',
            prop: 'chargeTotal',
            rules: [
              {
                required: true,
                message: '请输入应收金额(单位：元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '应收-实收金额(单位：元）',
            prop: 'discountAmount',
            rules: [
              {
                required: true,
                message: '请输入应收-实收金额(单位：元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '实际缴费金额(单位：元）',
            prop: 'chargeAmount',
            rules: [
              {
                required: true,
                message: '请输入实际缴费金额(单位：元）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注信息',
            prop: 'remark',
            rules: [
              {
                required: true,
                message: '请输入备注信息',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.parkcarout_add, false),
        viewBtn: this.vaildData(this.permission.parkcarout_view, false),
        delBtn: this.vaildData(this.permission.parkcarout_delete, false),
        editBtn: this.vaildData(this.permission.parkcarout_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
